export default {"src":"/_next/static/media/ELK Stack.7b4280e3.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};